import { useMsal } from "@azure/msal-react";
import { Button, Modal, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconTrash } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";
import { memo, useState } from "react";
import { deleteAllChats } from "src/utils/deleteChats";

export const DeleteChatsModal = memo(function DeleteChatsModal({ onOpen }: { onOpen: () => void }) {
    const [opened, { open, close }] = useDisclosure(false, { onOpen });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { instance } = useMsal();

    return (
        <>
            <Button
                onClick={open}
                variant="outline"
                color="red"
                leftSection={<IconTrash size={20} />}
            >
                Delete Chats
            </Button>
            <Modal opened={opened} onClose={close} title="Delete Chats" size="md" withinPortal>
                <Stack>
                    <Text size="sm">Are you sure you want to delete your chats?</Text>
                    <Button
                        onClick={async () => {
                            setLoading(true);
                            try {
                                await deleteAllChats(instance, navigate);
                                close();
                            } catch (err) {
                                console.error("Failed to delete all chats:", err);
                            } finally {
                                setLoading(false);
                            }
                        }}
                        color="red"
                        loading={loading}
                    >
                        Delete
                    </Button>
                </Stack>
            </Modal>
        </>
    );
});
